namespace $.$$ {

	const { rem } = $mol_style_unit

	$mol_style_define( $eve_slider, {
		alignItems: 'stretch',
		maxWidth: rem( 24 ),

		Label: {
			fontSize: rem( 0.875 ),
		},

		Input: {
			width: '100%',
			accentColor: 'currentcolor',
		},
	} )

}
